import React, { useState, useEffect } from "react";
import CheckOutHeader from "./CheckOutComponents/CheckOutHeader";
import axios from "axios";
import CheckOutPersonalInfo from "./CheckOutComponents/CheckOutPersonalInfo";
import CheckOutOrderSection from "./CheckOutComponents/CheckOutOrderSection";
import CheckOutDeliveryDetails from "./CheckOutComponents/CheckOutDeliveryDetails";
import ArrowDown from "../Images/ArrowDown.png";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function CheckOut() {
  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));

  //For CheckOutDeliveryDetails comp
  const [OBJForCheckOutDeliveryDetails, setOBJForCheckOutDeliveryDetails] =
    useState({});
  const [AcceptTerms, setAcceptTerms] = useState(0);
  const [OpenCommentSection, setOpenCommentSection] = useState(false);
  const [OpenPromoCode, setOpenPromoCode] = useState(false);
  const [TheText, setTheText] = useState("");
  const [PromoCode, setPromoCode] = useState("");
  const [PromoCode2, setPromoCode2] = useState(null);

  //End for CheckOutDeliveryDetails comp

  //For PaymentPage inside CheckOutDeliveryDetails comp
  const [cardNumber, setCardNumber] = useState("");
  const [ExpirtyDate, setExpirtyDate] = useState("");
  const [CVV, setCVV] = useState("");
  const [NameCardHolder, setNameCardHolder] = useState("");
  const [cardType, setCardType] = useState(null);

  //End For PaymentPage inside CheckOutDeliveryDetails comp
  const [ErrNoAddress, setErrNoAddress] = useState(false);
  const GetAddresses = () => {
    const data = {
      UserId: user?.userId,
    };
    // Fetch data when the component mounts
    axios
      .post(`${MyDomain}Addresses/GetChoosedAddress`, data) // Replace with your API endpoint
      .then((response) => {
        console.log(response.data);
        setErrNoAddress(false);

        setOBJForCheckOutDeliveryDetails(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
        setErrNoAddress(true);
      });
  };
  useEffect(() => {
    GetAddresses();
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [Choose, setChoose] = useState(0);
  const [ShowMobileOrder, setShowMobileOrder] = useState(true);

  const handleAction = () => {
    setChoose(1); // Update the state
  };

  return (
    <div>
      <CheckOutHeader />
      <div
        style={{
          paddingTop: 40,
          flexDirection: windowWidth <= 1024 ? "column" : "row",
          display: "flex",
          width: "100%",
          height: "calc(90vh - 55px)",
          paddingLeft: windowWidth <= 1024 ? "2%" : "0%",
          paddingRight: windowWidth <= 1024 ? "2%" : "0%",
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        {windowWidth <= 1024 ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 15,
              }}
              onClick={() => {
                setShowMobileOrder(!ShowMobileOrder);
              }}
            >
              <a
                style={{
                  cursor: "pointer",
                  fontSize: 18,
                  fontWeight: "500",
                }}
              >
                {t("profile.Yourorders")}
              </a>
              <span
                style={{
                  display: "inline-block",
                  transition: "transform 0.3s ease", // Smooth transition for the rotation
                  transform: ShowMobileOrder
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                  color: "black",
                }}
              >
                <img
                  src={ArrowDown}
                  style={{
                    width: 12,
                    height: 12,
                    opacity: 0.5,
                  }}
                />
              </span>
            </div>

            <div
              style={{
                display: "flex",
                width: windowWidth <= 1024 ? "100%" : "40%",
              }}
            >
              {ShowMobileOrder ? (
                <>
                  <CheckOutOrderSection
                    OBJForCheckOutDeliveryDetails={
                      OBJForCheckOutDeliveryDetails
                    }
                    AcceptTerms={AcceptTerms}
                    setAcceptTerms={setAcceptTerms}
                    setOpenCommentSection={setOpenCommentSection}
                    OpenCommentSection={OpenCommentSection}
                    setOpenPromoCode={setOpenPromoCode}
                    OpenPromoCode={OpenPromoCode}
                    setTheText={setTheText}
                    TheText={TheText}
                    setPromoCode={setPromoCode}
                    PromoCode={PromoCode}
                    setPromoCode2={setPromoCode2}
                    PromoCode2={PromoCode2}
                    //PaymentPage
                    setCardNumber={setCardNumber}
                    cardNumber={cardNumber}
                    setExpirtyDate={setExpirtyDate}
                    ExpirtyDate={ExpirtyDate}
                    setCVV={setCVV}
                    CVV={CVV}
                    setNameCardHolder={setNameCardHolder}
                    NameCardHolder={NameCardHolder}
                    setCardType={setCardType}
                    cardType={cardType}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          style={{
            display: "flex",
            width: windowWidth <= 1024 ? "100%" : "60%",
            flexDirection: "column",
          }}
        >
          {windowWidth <= 1024 ? (
            <></>
          ) : (
            <>
              <p
                style={{
                  fontSize: 30,
                  margin: 0,
                  fontWeight: "500",
                }}
              >
                {t("profile.Checkout")}
              </p>
            </>
          )}

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              flexDirection: "column",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              paddingRight: i18n.resolvedLanguage === "en" ? 0 : 20,
            }}
          >
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
                width: windowWidth <= 1024 ? "100%" : "50%",
                paddingBottom: 50,
              }}
            >
              <a
                style={{
                  fontSize: 18,
                  cursor: "pointer",
                  opacity: Choose === 0 ? 1 : 0.5,
                  color: Choose === 0 ? "#6b21a8" : "",
                  fontWeight: "500",
                }}
                onClick={() => {
                  setChoose(0);
                }}
              >
                1 &nbsp;{t("profile.Personalinfo")}&nbsp;
                {t("profile.and")}&nbsp;{t("profile.Deliverydetails")}
              </a>
              {/* <a
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  opacity: Choose === 1 ? 1 : 0.5,
                  color: Choose === 1 ? "#6b21a8" : "",
                  fontWeight: "500",
                }}
                onClick={() => {
                  if (!ErrNoAddress) setChoose(1);
                }}
              >
                2 &nbsp;{t("profile.Deliverydetails")}
              </a> */}
            </div>

            {Choose === 0 ? (
              <>
                <CheckOutPersonalInfo
                  onAction={handleAction}
                  OBJForCheckOutDeliveryDetails={OBJForCheckOutDeliveryDetails}
                  setOBJForCheckOutDeliveryDetails={
                    setOBJForCheckOutDeliveryDetails
                  }
                />
                <CheckOutDeliveryDetails
                  OBJForCheckOutDeliveryDetails={OBJForCheckOutDeliveryDetails}
                  AcceptTerms={AcceptTerms}
                  setAcceptTerms={setAcceptTerms}
                  setOpenCommentSection={setOpenCommentSection}
                  OpenCommentSection={OpenCommentSection}
                  setOpenPromoCode={setOpenPromoCode}
                  OpenPromoCode={OpenPromoCode}
                  setTheText={setTheText}
                  TheText={TheText}
                  setPromoCode={setPromoCode}
                  PromoCode={PromoCode}
                  setPromoCode2={setPromoCode2}
                  PromoCode2={PromoCode2}
                  //PaymentPage
                  setCardNumber={setCardNumber}
                  cardNumber={cardNumber}
                  setExpirtyDate={setExpirtyDate}
                  ExpirtyDate={ExpirtyDate}
                  setCVV={setCVV}
                  CVV={CVV}
                  setNameCardHolder={setNameCardHolder}
                  NameCardHolder={NameCardHolder}
                  setCardType={setCardType}
                  cardType={cardType}
                />
              </>
            ) : (
              <>
                <CheckOutDeliveryDetails
                  OBJForCheckOutDeliveryDetails={OBJForCheckOutDeliveryDetails}
                  AcceptTerms={AcceptTerms}
                  setAcceptTerms={setAcceptTerms}
                  setOpenCommentSection={setOpenCommentSection}
                  OpenCommentSection={OpenCommentSection}
                  setOpenPromoCode={setOpenPromoCode}
                  OpenPromoCode={OpenPromoCode}
                  setTheText={setTheText}
                  TheText={TheText}
                  setPromoCode={setPromoCode}
                  PromoCode={PromoCode}
                  setPromoCode2={setPromoCode2}
                  PromoCode2={PromoCode2}
                  //PaymentPage
                  setCardNumber={setCardNumber}
                  cardNumber={cardNumber}
                  setExpirtyDate={setExpirtyDate}
                  ExpirtyDate={ExpirtyDate}
                  setCVV={setCVV}
                  CVV={CVV}
                  setNameCardHolder={setNameCardHolder}
                  NameCardHolder={NameCardHolder}
                  setCardType={setCardType}
                  cardType={cardType}
                />
              </>
            )}
          </div>
        </div>
        {windowWidth <= 1024 ? (
          <></>
        ) : (
          <div style={{ display: "flex", width: "40%" }}>
            <CheckOutOrderSection
              setPromoCode2={setPromoCode2}
              PromoCode2={PromoCode2}
            />
          </div>
        )}
      </div>
    </div>
  );
}
//ErrNoAddress
